<template>
  <div class="shift-approval-selection" v-click-outside="outClose">
    <div class="table-responsive">
      <table class="table">
        <tbody>
          <tr class="center-me" v-if="!edit">
            <th>
              <button
                class="btn btn-sm btn-success"
                @click="approveShift()"
                v-if="shiftStatus === undefined && shift.choice_id !== 4 && noShiftChosen === null"
              >
                Approve This Choice
              </button>

              <button
                class="btn btn-sm btn-danger"
                @click="cancelShiftApproval()"
                v-if="shiftStatus !== undefined && shift.choice_id !== 4 && noShiftChosen === null"
              >
                Cancel Approval
              </button>

              <button
                class="btn btn-sm btn-success"
                v-if="noShiftChosen !== null && shiftStatus === undefined"
              >
                SELECT SHIFT
              </button>
            </th>
          </tr>
          <tr class="center-me" v-if="!edit">
            <td style="padding: 2px">
              <hr
                class="hr-text"
                data-content="Or change shift to:"
                v-if="shift.choice_id !== 4 && noShiftChosen === null"
              />
              <h6 class="h6" v-if="shift.choice_id === 4 && noShiftChosen === null">CHANGE SHIFT TO</h6>
            </td>
          </tr>
          <tr v-for="(s, index) in IsFriday === true ? fridayChoices : shiftChoices" :key="s.id" :id="index" v-if="!edit && shift.choice_id !== 4 && noShiftChosen === null">
            <td class="shift-name" @click="changeShift(s.id)">
              {{ s.name }}
              <div v-if="userStrength.length > 0 &&index === 0">
                {{checkUserStatsForShift(s.user_id, 'morning_dep_ratio')}}
              </div>
              <div v-if="userStrength.length > 0 && index === 1">
                {{checkUserStatsForShift(s.user_id, 'noon_dep_ratio')}}
              </div>
              <div v-if="userStrength.length > 0 && index === 2">
                {{checkUserStatsForShift(s.user_id, 'evening_dep_ratio')}}
              </div>
            </td>
          </tr>

          <tr v-for="(s, index) in IsFriday === true ? fridayChoicesNoAny : shiftChoicesNoAny" :key="s.id" :id="index" v-if="shift.choice_id === 4 && noShiftChosen === null">
            <td class="shift-name" @click="changeShift(s.id)">
              {{ s.name }}
              <div v-if="userStrength.length > 0 &&index === 0">
                {{checkUserStatsForShift(s.user_id, 'morning_dep_ratio')}}
              </div>
              <div v-if="userStrength.length > 0 && index === 1">
                {{checkUserStatsForShift(s.user_id, 'noon_dep_ratio')}}
              </div>
              <div v-if="userStrength.length > 0 && index === 2">
                {{checkUserStatsForShift(s.user_id, 'evening_dep_ratio')}}
              </div>
            </td>
          </tr>
        <tr v-if="edit" v-for="(item, index) in changeOptions" :key="index" class="center-me">
          <td class="shift-name">
            <div @click="changeAllNextWeek(item.id, user.id)">Change all to {{item.name}}</div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";

import apiClientCreator from "../../../helpers/api/request";
import moment from "moment";
export default {
  name: "ShiftsDropdown",
  props: {
    filterDates: {
      type: Object
    },
    user: {
      type: Object,
      default: null
    },
    edit:{
      type: Boolean,
      default: false
    },
    noShiftChosen:{
      type: Object,
      default: null
    },
    shift: {
      type: Object
    },
    shiftStatus: {
      type: String
    },
    userStrength:{
      type: Array,
      required: false,
      default: () => []
    },
    IsFriday:{
      type: Boolean,
      default: false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },

  data() {
    return {
      shiftChoices: [
        {
          id: 1,
          name: "MORNING: 09:00 - 17:00"
        },
        {
          id: 2,
          name: "NOON: 12:00 - 20:00"
        },
        {
          id: 3,
          name: "EVENING: 15:00 - 23:00"
        },
        {
          id: 4,
          name: "Any"
        },
        // {
        //   id: 5,
        //   name: "DO NOT CARE"
        // },
        {
          id: 6,
          name: "VACATION"
        },
        // {
        //   id: 7,
        //   name: "CUSTOM"
        // },
        {
          id: 8,
          name: "ILLNESS"
        }
      ],
      fridayChoices: [
        {
          id: 1,
          name: "MORNING: 09:00 - 16:00"
        },
        {
          id: 2,
          name: "NOON: 11:00 - 18:00"
        },
        {
          id: 3,
          name: "EVENING: 14:00 - 21:00"
        },
        {
          id: 4,
          name: "Any"
        },
        {
          id: 6,
          name: "VACATION"
        },
        {
          id: 7,
          name: "CUSTOM"
        },
        {
          id: 8,
          name: "ILLNESS"
        }
      ],

      shiftChoicesNoAny: [
        {
          id: 1,
          name: "MORNING: 09:00 - 17:00"
        },
        {
          id: 2,
          name: "NOON: 12:00 - 20:00"
        },
        {
          id: 3,
          name: "EVENING: 15:00 - 23:00"
        },
        // {
        //   id: 5,
        //   name: "DO NOT CARE"
        // },
        {
          id: 6,
          name: "VACATION"
        },
        // {
        //   id: 7,
        //   name: "CUSTOM"
        // },
        {
          id: 8,
          name: "ILLNESS"
        }
      ],
      fridayChoicesNoAny: [
        {
          id: 1,
          name: "MORNING: 09:00 - 16:00"
        },
        {
          id: 2,
          name: "NOON: 11:00 - 18:00"
        },
        {
          id: 3,
          name: "EVENING: 14:00 - 21:00"
        },
        {
          id: 6,
          name: "VACATION"
        },
        {
          id: 7,
          name: "CUSTOM"
        },
        {
          id: 8,
          name: "ILLNESS"
        }
      ],
      changeOptions: [
        {
          id: 1,
          name: "morning"
        },
        {
          id: 2,
          name: "noon"
        },
        {
          id: 3,
          name: "evening"
        },
      ]
    };
  },


  methods: {
    changeAllNextWeek(shiftId, userId){
      let changeAllNextWeek = apiClientCreator(`shifts/change_all_next_week`);
      changeAllNextWeek.post("",  {
          choice_id: shiftId,
          user_id: userId
        }).then(res => {
        this.$emit("closeDropdown");
      });
    },
    checkUserStatsForShift(user_id, det_ratio){
      let a = this.userStrength;

      if (a.some(s => s.user_id === user_id)) {
        let type = "dep ratio";
        let sent = "";
        a.some(s => {
          if (s.user_id === user_id) {
            sent = `dep ratio is ${item.morning_dep_ratio}`;
          }
        });
        if (type === "dep ratio") {
          return sent;
        }
      }

    },
    outClose() {
      this.$emit("closeDropdown");
    },
    cancelShiftApproval() {
      let getShiftList = apiClientCreator(
        `shifts/cancel_shift_approval/${this.shift.id}`
      );
      getShiftList.post("", {}).then(res => {
        this.$emit("closeDropdown");
      });
    },
    approveShift() {
      let getShiftList = apiClientCreator(
        `shifts/approve_user_choice/${this.shift.id}`
      );
      getShiftList.post("", {}).then(res => {
        this.$emit("closeDropdown");
      });
    },

    changeShift(choice) {
      if(this.noShiftChosen === null){
        let getShiftList = apiClientCreator(
            `shifts/change_user_choice/${this.shift.id}`
        );
        getShiftList
            .post("", {
              choice_id: choice
            })
            .then(res => {
              this.$emit("closeDropdown");
            });
      }
      if(this.noShiftChosen !== null){
        this.selectShift(choice)
      }
    },


    selectShift(choice) {
      let getShiftList = apiClientCreator(`shifts/select_user_choice`);
      getShiftList.post("", {user_id: this.noShiftChosen.user_id, choice_id: choice, day: this.noShiftChosen.day }).then(res => {
        this.$emit("closeDropdown");
      });
    },
  }
};
</script>

<style scoped>
.center-me {
  display: flex;
  align-items: center;
  justify-content: center;
}

.shift-approval-selection {
  position: absolute;
  z-index: 200;
  width: -moz-max-content;
  width: max-content;
  background-color: #ffffff;
  border: solid 1px #c30000;
  font-size: 12px;
  font-weight: normal;
  bottom: 0;
}
.shift-name {
  text-align: center;
  padding: 2px;
  font-size: 11px;

}

.shift-name:hover {
  background-color: #2e6da4;
  cursor: pointer;
}

.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: 0.8;
}
.hr-text-all-good {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: #000000;
  text-align: center;
  height: 1.5em;
  opacity: 1;
}
.hr-text-all-good:before {
  content: "";
  background: linear-gradient(to right, transparent, #818078, transparent);
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}
.hr-text-all-good:after {
  content: attr(data-content);
  position: relative;
  display: inline-block;
  color: black;
  padding: 0 0.5em;
  line-height: 1.5em;
  color: #818078;
  background-color: #fcfcfa;
}
.hr-text:before {
  content: "";
  background: linear-gradient(to right, transparent, #818078, transparent);
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}
.hr-text:after {
  content: attr(data-content);
  position: relative;
  display: inline-block;
  color: black;
  padding: 0 0.5em;
  line-height: 1.5em;
  color: #818078;
  background-color: #fcfcfa;
}
</style>
